(() => {
  'use strict';
  const stores = Array.isArray(window.KATADYN_DEALERS) ? window.KATADYN_DEALERS : [];
  const config = window.KATADYN_MAP_CONFIG || {};
  // Shopify 版以 [data-kdl-root] 限定範圍，避免與佈景主題內同名 id（如 search）衝突；本機預覽無此屬性。
  const root = document.querySelector('[data-kdl-root]') || document;
  const el = id => root === document ? document.getElementById(id) : root.querySelector('#' + id);
  const search = el('search'), city = el('city'), list = el('results-list');
  const canvas = el('map-canvas'), status = el('map-status'), help = el('map-help');
  const mapLink = el('map-link'), phone = el('phone-link');
  const regionButtons = [...root.querySelectorAll('.region-button')];
  const viewButtons = [...root.querySelectorAll('.view-button')];
  const normalize = value => String(value || '').normalize('NFKC').replace(/臺/g, '台').toLowerCase();
  const storeCity = s => normalize(s.city || (s.address.match(/^[^市縣\s]{2,3}[市縣]/) || ['其他'])[0]);
  const validPoint = s => Number.isFinite(s.lat) && Number.isFinite(s.lng) &&
    s.lat >= 21 && s.lat <= 26 && s.lng >= 119 && s.lng <= 123;
  const mapUrl = s => 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.name + ' ' + s.address);
  let region = '', selected = -1, visible = [], map, info, Marker, Pin, Clusterer, cluster;
  let markers = [], markersByIndex = new Map(), loadState = 'idle', timeout;
  const nearestButton = el('find-nearest'), clearNearest = el('clear-nearest'), nearbyMessage = el('nearby-message');
  let userPosition = null, userMarker = null, locating = false;
  const distanceKm = (a,b) => {
    const radians = degrees => degrees * Math.PI / 180;
    const lat = radians(b.lat - a.lat), lng = radians(b.lng - a.lng);
    const h = Math.sin(lat/2) ** 2 + Math.cos(radians(a.lat)) * Math.cos(radians(b.lat)) * Math.sin(lng/2) ** 2;
    return 6371.0088 * 2 * Math.asin(Math.sqrt(Math.min(1,Math.max(0,h))));
  };
  // 預設依店名 A–Z：英文店名在前（A–Z），中文店名依拼音 A–Z 接在後
  const nameCollator = new Intl.Collator('zh-u-co-pinyin', {sensitivity:'base', numeric:true});
  const isLatinName = s => /^[A-Za-z0-9]/.test(String(s.name || '').normalize('NFKC'));
  const nameOrder = new Map(stores.map((s,index) => ({s,index}))
    .sort((a,b) => isLatinName(b.s) - isLatinName(a.s) || nameCollator.compare(a.s.name,b.s.name) || a.index - b.index)
    .map((item,rank) => [item.index,rank]));
  const formatDistance =km => km < 0.1 ? '距離約 100 公尺內' : '直線距離約 ' + km.toFixed(1) + ' 公里';

  const totalCount = el('total-count'); // 頁面已移除總數文字；保留相容，有此元素才更新
  if (totalCount) totalCount.textContent = String(stores.length);
  [...new Set(stores.map(storeCity))].sort(new Intl.Collator('zh-Hant-TW').compare).forEach(value => {
    const option = document.createElement('option');
    option.value = option.textContent = value;
    city.append(option);
  });

  function setView(view) {
    el('content-grid').dataset.view = view;
    viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    // A map initialized while the mobile map panel is hidden needs its bounds restored when shown.
    if (view === 'map' && map) {
      google.maps.event.trigger(map, 'resize');
      fitResults();
    }
  }
  function popup(s) {
    const box = document.createElement('div'), title = document.createElement('strong');
    const address = document.createElement('div'), link = document.createElement('a');
    box.className = 'map-info';
    title.textContent = s.name;
    address.textContent = s.address;
    link.href = mapUrl(s); link.target = '_blank'; link.rel = 'noopener noreferrer';
    link.textContent = '在 Google 地圖開啟 ↗';
    box.append(title, address, link);
    return box;
  }
  function select(index, focus = false, fromMarker = false) {
    const s = stores[index];
    selected = s ? index : -1;
    el('selected-name').textContent = s ? s.name : '沒有符合條件的門市';
    el('selected-address').textContent = s ? s.address : '請調整搜尋條件';
    phone.textContent = s && s.phone ? s.phone : '—';
    if (s) { mapLink.href = mapUrl(s); mapLink.removeAttribute('aria-disabled'); }
    else { mapLink.removeAttribute('href'); mapLink.setAttribute('aria-disabled', 'true'); }
    if (s && s.phone) phone.href = 'tel:' + s.phone.replace(/[^\d+]/g, '');
    else phone.removeAttribute('href');
    list.querySelectorAll('.store-card').forEach(card => {
      const active = Number(card.dataset.index) === selected;
      card.setAttribute('aria-pressed', String(active));
      if (active && fromMarker) card.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    });
    if (!s) { if (info) info.close(); return; }
    help.textContent = validPoint(s) ? '點選門市或標記，查看位置與導航' : '此門市座標待核對；可使用 Google 地圖導航';
    if (!focus || !map) return;
    if (!fromMarker) setView('map');
    if (!validPoint(s)) { info.close(); return; }
    const point = {lat: s.lat, lng: s.lng};
    map.panTo(point); map.setZoom(16);
    info.setContent(popup(s));
    // Open by position: this also works when a marker is currently hidden inside a cluster.
    info.setPosition(point); info.open({map, shouldFocus: false});
  }
  function renderList() {
    list.replaceChildren();
    el('result-count').textContent = '顯示 ' + visible.length + ' 間';
    if (!visible.length) {
      const empty = document.createElement('p'); empty.className = 'empty';
      empty.textContent = '找不到符合條件的門市，請試試其他關鍵字。';
      list.append(empty); select(-1); return;
    }
    visible.forEach(({s, index, distance}) => {
      const card = document.createElement('button'); card.type = 'button';
      card.className = 'store-card'; card.dataset.index = String(index);
      const area = document.createElement('span'), title = document.createElement('span');
      const address = document.createElement('span');
      area.className = 'store-region'; area.textContent = s.region + ' · ' + storeCity(s);
      title.className = 'store-name'; title.textContent = s.name;
      address.className = 'store-address'; address.textContent = s.address;
      card.append(area, title, address);
      if (Number.isFinite(distance)) {
        const label = document.createElement('span'); label.className = 'store-distance';
        label.textContent = formatDistance(distance); card.append(label);
      }
      if (!validPoint(s)) {
        const pending = document.createElement('span'); pending.className = 'location-status';
        pending.textContent = '可查詢電話與導航 · 標記待核對'; card.append(pending);
      }
      card.addEventListener('click', () => select(index, true)); list.append(card);
    });
    select(visible.some(item => item.index === selected) ? selected : visible[0].index);
  }
  function progress() {
    const located = visible.filter(({s}) => validPoint(s)).length;
    status.textContent = '顯示 ' + located + ' 個標記' + (visible.length > located ? ' · ' + (visible.length - located) + ' 間待核對' : '');
  }
  function fitResults() {
    if (!map) return;
    const points = visible.filter(({s}) => validPoint(s));
    if (!points.length) { map.setCenter({lat:23.7,lng:121}); map.setZoom(7); return; }
    if (points.length === 1) {
      map.setCenter({lat:points[0].s.lat,lng:points[0].s.lng}); map.setZoom(16); return;
    }
    const bounds = new google.maps.LatLngBounds();
    points.forEach(({s}) => bounds.extend({lat:s.lat,lng:s.lng}));
    map.fitBounds(bounds, 48);
  }
  function renderMarkers() {
    if (!map || !Marker) return;
    if (info) info.close();
    if (cluster) { cluster.clearMarkers(); cluster.setMap(null); cluster = null; }
    markers.forEach(marker => { marker.map = null; });
    markers = []; markersByIndex.clear();
    visible.forEach(({s,index}) => {
      if (!validPoint(s)) return;
      const marker = new Marker({position:{lat:s.lat,lng:s.lng}, title:s.name + '，' + s.address, map:Clusterer ? null : map});
      marker.append(new Pin({background:'#121212',borderColor:'#121212',glyphColor:'#fff'}));
      marker.addListener('click', () => select(index, true, true));
      markers.push(marker); markersByIndex.set(index, marker);
    });
    if (Clusterer && markers.length) cluster = new Clusterer({map,markers});
    renderUserMarker();
    fitResults(); progress();
  }
  function renderUserMarker() {
    if (userMarker) { userMarker.map = null; userMarker = null; }
    if (!map || !Marker || !userPosition) return;
    const dot = document.createElement('div'); dot.className = 'user-location-dot';
    userMarker = new Marker({map,position:userPosition,title:'你目前的位置',zIndex:10000});
    userMarker.append(dot);
  }
  function focusNearest() {
    const nearest = visible.find(item => Number.isFinite(item.distance));
    if (!nearest) return;
    select(nearest.index);
    if (!map) return;
    setView('map');
    const bounds = new google.maps.LatLngBounds();
    bounds.extend(userPosition); bounds.extend({lat:nearest.s.lat,lng:nearest.s.lng});
    map.fitBounds(bounds,64);
    google.maps.event.addListenerOnce(map,'idle', () => {
      if (map.getZoom() > 16) map.setZoom(16);
    });
    info.setContent(popup(nearest.s));
    info.setPosition({lat:nearest.s.lat,lng:nearest.s.lng}); info.open({map,shouldFocus:false});
  }
  function render() {
    const term = normalize(search.value.trim());
    visible = stores.map((s,index) => ({s,index})).filter(({s}) =>
      (!region || s.region === region) && (!city.value || storeCity(s) === city.value) &&
      (!term || normalize(s.name + ' ' + s.address + ' ' + s.phone).includes(term)));
    if (userPosition) {
      visible.forEach(item => { item.distance = validPoint(item.s) ? distanceKm(userPosition,item.s) : Infinity; });
      visible.sort((a,b) => a.distance - b.distance || nameOrder.get(a.index) - nameOrder.get(b.index));
    } else {
      visible.sort((a,b) => nameOrder.get(a.index) - nameOrder.get(b.index));
    }
    renderList(); renderMarkers();
  }
  function findNearest() {
    if (locating) return;
    if (!navigator.geolocation) {
      nearbyMessage.textContent = '此瀏覽器不支援定位，請使用縣市或地址搜尋。'; return;
    }
    locating = true; nearestButton.disabled = true;
    nearbyMessage.textContent = '正在取得目前位置，請允許瀏覽器使用定位…';
    navigator.geolocation.getCurrentPosition(position => {
      locating = false; nearestButton.disabled = false;
      const point = {lat:position.coords.latitude,lng:position.coords.longitude};
      if (!Number.isFinite(point.lat) || !Number.isFinite(point.lng) || Math.abs(point.lat)>90 || Math.abs(point.lng)>180) {
        nearbyMessage.textContent = '未取得有效位置，請重新定位或使用地址搜尋。'; return;
      }
      userPosition = point; selected = -1; region = ''; city.value = ''; search.value = '';
      regionButtons.forEach(button => button.setAttribute('aria-pressed',String(!button.dataset.region)));
      clearNearest.hidden = false;
      const available = stores.filter(validPoint).length;
      const pending = stores.length - available;
      nearbyMessage.textContent = '已依直線距離排序 ' + available + ' 間門市' + (pending ? '；' + pending + ' 間座標待核對，列於最後。' : '。');
      render(); focusNearest();
    }, error => {
      locating = false; nearestButton.disabled = false;
      const message = error.code === 1 ? '未允許定位，請在瀏覽器開啟位置權限，或使用縣市搜尋。' :
        error.code === 3 ? '定位逾時，請再試一次，或使用縣市搜尋。' : '暫時無法取得位置，請再試一次，或使用縣市搜尋。';
      nearbyMessage.textContent = message + (userPosition ? '目前仍保留上次的距離排序。' : '');
    }, {enableHighAccuracy:true,timeout:12000,maximumAge:60000});
  }
  function notice(message) {
    status.textContent = message;
    el('map-placeholder-title').textContent = 'Google 地圖尚未載入';
    el('map-placeholder-text').textContent = message;
  }
  function fail(message) {
    // A failed Google loader cannot reliably be reinitialized in the same page; a reload is required.
    clearTimeout(timeout); loadState = 'failed';
    canvas.dataset.mode = 'pending'; notice(message);
  }
  function loadScript(src, milliseconds) {
    return new Promise((resolve,reject) => {
      const script = document.createElement('script'); script.async = true; script.src = src;
      const timer = setTimeout(() => reject(new Error('load-timeout')), milliseconds);
      script.onload = () => { clearTimeout(timer); resolve(); };
      script.onerror = () => { clearTimeout(timer); reject(new Error('load-failed')); };
      document.head.append(script);
    });
  }
  async function startMap() {
    if (loadState !== 'loading') return;
    const [{Map:GoogleMap,InfoWindow},{AdvancedMarkerElement,PinElement}] = await Promise.all([
      google.maps.importLibrary('maps'), google.maps.importLibrary('marker')
    ]);
    if (loadState !== 'loading') return;
    Marker = AdvancedMarkerElement; Pin = PinElement;
    map = new GoogleMap(el('google-map'), {
      center:{lat:23.7,lng:121},zoom:7,mapId:config.mapId || 'DEMO_MAP_ID',
      mapTypeControl:false,streetViewControl:false,fullscreenControl:true,gestureHandling:'cooperative'
    });
    info = new InfoWindow();
    // 程式庫已載入、地圖已建立，就取消載入逾時：手機預設是清單檢視，地圖容器隱藏時底圖不會載入、
    // tilesloaded 不會觸發，若仍等它就會在 25 秒後誤判逾時。金鑰或授權失敗另由 gm_authFailure 處理。
    clearTimeout(timeout);
    map.addListener('tilesloaded', () => {
      if (loadState !== 'loading') return;
      clearTimeout(timeout); loadState = 'ready'; canvas.dataset.mode = 'google';
      progress();
    });
    // Show the map during initial tile loading; authorization failures restore the placeholder.
    canvas.dataset.mode = 'google'; renderMarkers();
    if (userPosition) focusNearest();
    try {
      await loadScript('https://unpkg.com/@googlemaps/markerclusterer@2.6.2/dist/index.min.js', 8000);
      if (loadState === 'failed') return;
      Clusterer = window.markerClusterer && window.markerClusterer.MarkerClusterer;
      if (Clusterer) { renderMarkers(); if (userPosition) focusNearest(); }
    } catch (_) { /* Pins remain usable if the optional clustering library is unavailable. */ }
  }
  function loadMap(key) {
    key = String(key || '').trim();
    if (loadState !== 'idle') return;
    if (key.startsWith('AQ.')) {
      notice('map-config.js 設定的是 AQ. 格式授權金鑰，不能用於此地圖。請工程師提供 Maps JavaScript API 的網站金鑰；門市清單與導航仍可使用。'); return;
    }
    if (!/^AIza[\w-]{30,100}$/.test(key)) {
      notice('map-config.js 的地圖金鑰格式不正確，請改填 Google Maps 網站金鑰；門市清單與導航仍可使用。'); return;
    }
    loadState = 'loading';
    status.textContent = '正在載入 Google 地圖…';
    el('map-placeholder-title').textContent = '正在載入 Google 地圖';
    el('map-placeholder-text').textContent = '請稍候，門市清單仍可使用。';
    window.gm_authFailure = () => fail('金鑰的地圖授權、網站限制或計費設定未通過。請工程師核對 Maps JavaScript API；清單與導航仍可使用。');
    window.__katadynGoogleMapsReady = () => startMap().catch(() => fail('Google 地圖初始化失敗，請重新整理後再試；門市清單仍可使用。'));
    const url = new URL('https://maps.googleapis.com/maps/api/js');
    Object.entries({key,v:'weekly',loading:'async',libraries:'marker',language:'zh-TW',region:'TW',callback:'__katadynGoogleMapsReady'})
      .forEach(([name,value]) => url.searchParams.set(name,value));
    timeout = setTimeout(() => fail('Google 地圖載入逾時。請確認網路與金鑰設定，門市清單仍可使用。'), 25000);
    loadScript(url.toString(), 20000).catch(() => fail('無法取得 Google 地圖程式，請確認網路連線；門市清單仍可使用。'));
  }
  regionButtons.forEach(button => button.addEventListener('click', () => {
    region = button.dataset.region || ''; city.value = '';
    regionButtons.forEach(item => item.setAttribute('aria-pressed',String(item === button))); render();
  }));
  viewButtons.forEach(button => button.addEventListener('click', () => setView(button.dataset.view)));
  search.addEventListener('input',render); city.addEventListener('change',render);
  el('map-reset').addEventListener('click', () => { if (info) info.close(); fitResults(); });
  nearestButton.addEventListener('click',findNearest);
  clearNearest.addEventListener('click', () => {
    userPosition = null; selected = -1; clearNearest.hidden = true;
    nearbyMessage.textContent = '已清除目前位置與距離排序，可繼續搜尋門市。';
    if (userMarker) { userMarker.map = null; userMarker = null; }
    render();
  });
  mapLink.addEventListener('click', event => { if (!mapLink.hasAttribute('href')) event.preventDefault(); });
  render();
  // The site key comes only from map-config.js; without one the list and navigation links still work.
  if (String(config.apiKey || '').trim()) loadMap(config.apiKey);
})();
